import * as R from 'ramda';

const paths = [
    ['startDate'],
    ['endDate'],
    ['rightsholders', 'selected'],
    ['sponsors', 'selected'],
    ['placements', 'selected'],
    ['placementTypes', 'selected'],
    ['accOwnTypes', 'selected'],
    ['mediaTypes', 'selected'],
    ['collections', 'selected'],
    ['accountUsernames'],
    ['audiencePlatforms', 'selected'],
    ['networks'],
    ['hashtags'],
    ['captions'],
    ['countries', 'selected'],
    ['broadcastNetworks', 'selected'],
    ['collaboratingAccountUsernames'],
];

const filterName = {
    startDate: 'startDate',
    endDate: 'endDate',
    rightsholders: 'rightsholderIds',
    sponsors: 'sponsorIds',
    placements: 'rightsholderPlacementIds',
    placementTypes: 'placementTypeIds',
    accOwnTypes: 'accountOwnershipTypeIds',
    mediaTypes: 'mediaTypeIds',
    accountUsernames: 'accountUsernames',
    networks: 'networks',
    hashtags: 'hashtags',
    captions: 'captions',
    collections: 'collectionIds',
    countries: 'networkCountryIds',
    broadcastNetworks: 'networkIds',
    collaboratingAccountUsernames: 'collaboratingAccountUsernames',
};

// @TODO memoize this
const getSelectedFilters = filters => {
    const formattedFilters = paths.reduce((acc, path) => {
        const val = R.path(path, filters);
        const name = filterName[path[0]];

        // Ignore empty arrays
        if (Array.isArray(val) && val.length === 0) return acc;

        if (val) acc[name] = val;

        return acc;
    }, {});

    const platforms = R.path(['platformPostTypePairs', 'selected'], filters);
    const audiencePlatforms = R.path(
        ['audiencePlatforms', 'selected'],
        filters,
    );
    const countries = R.path(['countries', 'selected'], filters);

    if (Array.isArray(audiencePlatforms) && audiencePlatforms.length > 0) {
        formattedFilters.audiencePlatforms = audiencePlatforms;
    }

    if (Array.isArray(platforms) && platforms.length > 0) {
        const platformPairs = platforms.map(id => {
            const [platformId, postTypeId] = id.split('-');
            return postTypeId ? { platformId, postTypeId } : { platformId };
        });
        formattedFilters.platformPostTypePairs = platformPairs;
    }

    // Enforce Broadcast Platform selection when using Countries
    if (Array.isArray(countries) && countries.length > 0) {
        formattedFilters.platformPostTypePairs = [{ platformId: '5' }];
    }

    // Authorship types: omit if none or all three selected (frontend optimization)
    // API expects an array e.g. ["standard", "collaboration"]
    const authorshipTypes = R.path(['authorshipTypes'], filters);
    if (
        Array.isArray(authorshipTypes) &&
        authorshipTypes.length > 0 &&
        authorshipTypes.length < 3
    ) {
        formattedFilters.authorshipTypes = authorshipTypes;
    }

    // Collaborating accounts: omit if empty. API expects array e.g. ["nike", "adidas"]
    const collaboratingAccountUsernames = R.path(
        ['collaboratingAccountUsernames'],
        filters,
    );
    if (
        Array.isArray(collaboratingAccountUsernames) &&
        collaboratingAccountUsernames.length > 0
    ) {
        formattedFilters.collaboratingAccountUsernames =
            collaboratingAccountUsernames;
    }

    const selectedRightsholderIds =
        formattedFilters.rightsholderIds ||
        R.path(['rightsholders', 'selected'], filters) ||
        [];
    const selectedPlacements =
        formattedFilters.rightsholderPlacementIds ||
        R.path(['placements', 'selected'], filters) ||
        [];
    const placementsList = R.path(['placements', 'list'], filters) || {};
    const hasPlacementsList = Object.keys(placementsList).length > 0;

    if (Array.isArray(selectedPlacements) && selectedPlacements.length > 0) {
        const selectedRightsholderSet = new Set(
            (selectedRightsholderIds || []).map(String),
        );
        const shouldFilterByRightsholder = selectedRightsholderSet.size > 0;

        formattedFilters.rightsholderPlacementIds = selectedPlacements.filter(
            placementId => {
                const [rhId, placementGroup] = `${placementId}`.split('-');
                if (!rhId || !placementGroup) return false;

                if (
                    shouldFilterByRightsholder &&
                    !selectedRightsholderSet.has(rhId)
                ) {
                    return false;
                }

                if (
                    hasPlacementsList &&
                    !Object.prototype.hasOwnProperty.call(
                        placementsList,
                        placementId,
                    )
                ) {
                    return false;
                }

                return true;
            },
        );

        if (formattedFilters.rightsholderPlacementIds.length === 0) {
            delete formattedFilters.rightsholderPlacementIds;
        }
    }

    return formattedFilters;
};

export default getSelectedFilters;
